import React, { memo, useMemo } from 'react';
import { NativeBaseProvider, ScrollView, Text, VStack } from 'native-base';
import theme from '../../theme';
import { OfferDisclosuresConstants } from '../../constants';
export default /*#__PURE__*/memo(_ref => {
  let {
    disclosureType = ''
  } = _ref;
  const disclosures = useMemo(() => {
    let disclosure = disclosureType.toUpperCase();
    if (disclosure.startsWith('ANC_CO')) {
      disclosure = 'CO';
    }
    switch (disclosure.toUpperCase()) {
      case 'CO':
        return OfferDisclosuresConstants.CO_DISCLOSURES;
      case 'SL':
        return OfferDisclosuresConstants.SL_DISCLOSURES;
      case 'RT':
        return OfferDisclosuresConstants.RT_DISCLOSURES;
      case 'PU':
        return OfferDisclosuresConstants.PU_DISCLOSURES;
      default:
        return OfferDisclosuresConstants.DEFAULT_DISCLOSURES;
    }
  }, [disclosureType]);
  return /*#__PURE__*/React.createElement(NativeBaseProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(ScrollView, {
    flex: 1
  }, /*#__PURE__*/React.createElement(VStack, {
    space: "42"
  }, /*#__PURE__*/React.createElement(Text, {
    fontFamily: "body",
    fontWeight: "normal",
    fontSize: {
      base: '22',
      sm: '22',
      md: '4xl',
      lg: '4xl'
    },
    testID: "Offer Terms and Disclosures",
    accessibilityLabel: "Offer Terms and Disclosures"
  }, "Offer Terms and Disclosures"), /*#__PURE__*/React.createElement(Text, {
    fontSize: "sm",
    fontWeight: "normal",
    fontFamily: "body",
    accessibilityLabel: disclosureType,
    testID: 'disclosures-text'
  }, disclosures))));
});
//# sourceMappingURL=OfferDisclosures.js.map